// extracted by mini-css-extract-plugin
export default {"buttonShort":"button_buttonShort__Hq+XL"};